import React from 'react';


const TradesHeader = () => {

    return (
        <>
            <section className="tasks-header" >
                <div className="icon"></div>
                <div className="title">Name</div>
                <div className="details">Details</div>
                <div className="status">Status</div>
            </section>
        </>
    );
}


export default TradesHeader;

